import { Participant } from "twilio-video";
import { usePublications } from "../hooks/usePublications";
import Publication from "./Publication";

interface Props {
	participant: Participant;
	isLocalParticipant: boolean;
}
export const ParticipantTracks = ({ participant, isLocalParticipant }: Props) => {
	const publications = usePublications(participant);

	return (
		<>
			{publications.map((publication) => (
				<Publication
					key={publication.kind}
					publication={publication}
					participant={participant}
					isLocalParticipant={isLocalParticipant}
				/>
			))}
		</>
	);
};
